import { render, staticRenderFns } from "./AlertEventDialogComponent.vue?vue&type=template&id=c6651562&scoped=true"
import script from "./AlertEventDialogComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventDialogComponent.vue?vue&type=style&index=0&id=c6651562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6651562",
  null
  
)

export default component.exports